import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../shared/config";
import { estDirecteur } from '../lib/droits';

// Un badge = une action attendue de l'utilisateur. Rafraîchi à chaque navigation, toutes les 60 s et sur l'événement `nav-badges-refresh`.
export const useNavBadges = (user, tree, navKey) => {
  const [badges, setBadges] = useState({});
  const isDir = estDirecteur(user, 'admin');
  const autos = user?.autorisations || {};
  const has = useCallback((screenId) => tree.sections.some(s => s.pages.some(p => !p.lien && p.screens.includes(screenId))) || tree.toolbar.some(t => t.screens.includes(screenId)), [tree]);

  const refresh = useCallback(async () => {
    if (!user) return;
    const next = {};
    const jobs = [];
    // Secrétaire : pastille = courriers traités par les médecins, dont elle gère la suite
    if (has('a-traiter')) jobs.push(axios.get(`${API}/dossiers-a-traiter?statut=${user.role === 'Secrétaire' ? 'TRAITE' : 'EN_ATTENTE'}`).then(r => { next.a_traiter = (Array.isArray(r.data) ? r.data : []).filter(x => user.role !== 'Médecin' || x.medecin_id === user.id || x.transfere_a_id === user.id).length; }).catch(() => {}));
    if (has('conges') && (isDir || autos.conges?.droits_directeur)) jobs.push(axios.get(`${API}/conges`).then(r => { next.conges = (Array.isArray(r.data) ? r.data : []).filter(d => d.statut === 'EN_ATTENTE').length; }).catch(() => {}));
    if (has('demandes-travail') && (isDir || user.role === 'Manager')) jobs.push(axios.get(`${API}/demandes-travail`).then(r => { next.jours = (Array.isArray(r.data) ? r.data : []).filter(d => d.statut === 'EN_ATTENTE').length; }).catch(() => {}));
    if (has('pare-feu')) jobs.push(axios.get(`${API}/securite/alertes-compteur`).then(r => { next.securite = r.data?.total || 0; }).catch(() => {}));
    if (has('messages')) jobs.push(axios.get(`${API}/messages/unread-counts`).then(r => { next.messages = r.data?.total || 0; }).catch(() => {}));
    await Promise.all(jobs);
    setBadges(next);
  }, [user, has, isDir, autos.conges?.droits_directeur]);

  useEffect(() => { refresh(); }, [refresh, navKey]);
  useEffect(() => {
    const id = setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 60000);
    window.addEventListener('nav-badges-refresh', refresh);
    return () => { clearInterval(id); window.removeEventListener('nav-badges-refresh', refresh); };
  }, [refresh]);
  return badges;
};
